"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PROPERTY_BADGE_STATUS_ICON = exports.PILL_TYPE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _toolTipTextOverflow = _interopRequireDefault(require("../toolTipTextOverflow"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var _styles2 = _interopRequireDefault(require("../toolTipTextOverflow/styles.scss"));
var _overlay = _interopRequireDefault(require("../overlay"));
var _ICON;
var CLASS_NAME = _styles.default['pill-box-container'];
var PILL_TYPE = {
  CHECK: 'check',
  CHECK_INPROGRESS: 'check-in-progress',
  CHECK_NOT_COMPLETED: 'check-not-completed',
  EXCLAMATION_UNDECIDED: 'exclamation-undecided',
  EXCLAMATION_DECLINED: 'exclamation-declined',
  EXCLAMATION_WITHDREW: 'exclamation-withdrew',
  EXCLAMATION_EXPIRED: 'exclamation-expired',
  CONSENTED: 'consented',
  NONCONSENTED: 'nonConsented',
  REDLABEL: 'red-label',
  LOCK: 'lock',
  UNLOCK: 'unlock',
  PAUSED: 'paused',
  X_MARK: 'x-mark'
};
exports.PILL_TYPE = PILL_TYPE;
var ICON = (_ICON = {}, (0, _defineProperty2.default)(_ICON, PILL_TYPE.CHECK, 'fas fa-check check-icon'), (0, _defineProperty2.default)(_ICON, PILL_TYPE.CHECK_INPROGRESS, 'fas fa-check check-icon in-pogress'), (0, _defineProperty2.default)(_ICON, PILL_TYPE.CHECK_NOT_COMPLETED, 'fas fa-check check-icon not-completed'), (0, _defineProperty2.default)(_ICON, PILL_TYPE.CONSENTED, 'consented'), (0, _defineProperty2.default)(_ICON, PILL_TYPE.NONCONSENTED, 'non-consented'), (0, _defineProperty2.default)(_ICON, PILL_TYPE.REDLABEL, ''), _ICON);
var PROPERTY_BADGE_STATUS_ICON = {
  CHECK_COMPLETE: {
    type: PILL_TYPE.CHECK,
    value: 'CHECK_COMPLETE',
    label: 'Check-Complete'
  },
  CHECK_IN_PROGRESS: {
    type: PILL_TYPE.CHECK_INPROGRESS,
    value: 'CHECK_IN_PROGRESS',
    label: 'Check-In Progress'
  },
  CHECK_NOT_COMPLETED: {
    type: PILL_TYPE.CHECK_NOT_COMPLETED,
    value: 'CHECK_NOT_COMPLETED',
    label: 'Check-Not Completed'
  },
  LOCK: {
    type: PILL_TYPE.LOCK,
    value: 'LOCK',
    label: 'Lock-Not Eligible'
  },
  UNLOCK: {
    type: PILL_TYPE.UNLOCK,
    value: 'UNLOCK',
    label: 'Unlock-Not Started'
  },
  EXCLAMATION_UNDECIDED: {
    type: PILL_TYPE.EXCLAMATION_UNDECIDED,
    value: 'EXCLAMATION_UNDECIDED',
    label: 'Exclamation-Undecided'
  },
  EXCLAMATION_DECLINED: {
    type: PILL_TYPE.EXCLAMATION_DECLINED,
    value: 'EXCLAMATION_DECLINED',
    label: 'Exclamation-Declined'
  },
  EXCLAMATION_WITHDREW: {
    type: PILL_TYPE.EXCLAMATION_WITHDREW,
    value: 'EXCLAMATION_WITHDREW',
    label: 'Exclamation-Withdrawn'
  },
  EXCLAMATION_EXPIRED: {
    type: PILL_TYPE.EXCLAMATION_EXPIRED,
    value: 'EXCLAMATION_EXPIRED',
    label: 'Exclamation-Expired'
  },
  PAUSE: {
    type: PILL_TYPE.PAUSED,
    value: 'PAUSE',
    label: 'Pause-In Progress'
  },
  X_MARK: {
    type: PILL_TYPE.X_MARK,
    value: 'X_MARK',
    label: 'X-mark-Not Available'
  }
};
exports.PROPERTY_BADGE_STATUS_ICON = PROPERTY_BADGE_STATUS_ICON;
var renderPillBoxType = function renderPillBoxType(type) {
  var classNameIcon = _lodash.default.get(ICON, type, ICON.times);
  switch (type) {
    case PILL_TYPE.LOCK:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-lock-keyhole fa-stack-1x"
      }));
    case PILL_TYPE.UNLOCK:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-lock-keyhole-open fa-stack-1x"
      }));
    case PILL_TYPE.EXCLAMATION_DECLINED:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x declined"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-exclamation fa-stack-1x"
      }));
    case PILL_TYPE.EXCLAMATION_WITHDREW:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x withdrew"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-exclamation fa-stack-1x"
      }));
    case PILL_TYPE.EXCLAMATION_EXPIRED:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x expired"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-exclamation fa-stack-1x"
      }));
    case PILL_TYPE.EXCLAMATION_UNDECIDED:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x undecided"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-exclamation fa-stack-1x"
      }));
    case PILL_TYPE.PAUSED:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x paused"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-pause fa-stack-1x"
      }));
    case PILL_TYPE.X_MARK:
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "fa-stack fa-lg"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-circle fa-stack-2x x-mark"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-xmark fa-stack-1x"
      }));
    default:
      return /*#__PURE__*/_react.default.createElement("i", {
        className: classNameIcon
      });
  }
};
/**
 * pill box
 * @param {Object} props
 */
var PillBox = function PillBox(props) {
  var t = props.t,
    hideToolTip = props.hideToolTip;
  if (_lodash.default.isNil(props.text)) {
    return null;
  }
  var pillText = props.status ? "".concat(t(props.text), "-").concat(t(props.status)) : t(props.text);
  var tooltipText = t(props.tooltip);
  var contentDisplay = /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflow: 'hidden',
      overflowWrap: 'break-word',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      wordBreak: 'break-all'
    }
  }, pillText);
  var renderContent = function renderContent() {
    // diable all toolTip.
    if (hideToolTip) {
      return contentDisplay;
    }
    return props.tooltip ?
    /*#__PURE__*/
    // hover tooltip
    _react.default.createElement(_overlay.default, {
      text: tooltipText,
      className: _styles2.default['tool-tip-overlay-wrapper'],
      defaultShowTooltip: false,
      setSameAsParentWidth: true,
      parentId: "".concat(pillText, "-tooltip"),
      position: props.position
    }, contentDisplay) :
    /*#__PURE__*/
    // text overflow tooltip
    _react.default.createElement(_toolTipTextOverflow.default, {
      isUseOverlayTooltip: true,
      setSameAsParentWidth: true,
      position: props.position
    }, pillText);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CLASS_NAME, " ").concat(props.className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "".concat(pillText, "-tooltip"),
    className: "pill-box ".concat(props.type)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pill-box-".concat(props.type)
  }, renderPillBoxType(props.type)), renderContent()));
};
PillBox.propTypes = {
  text: _propTypes.default.string,
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(_lodash.default.map(PILL_TYPE)),
  status: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  position: _propTypes.default.shape({
    left: _propTypes.default.string,
    top: _propTypes.default.string
  }),
  t: _propTypes.default.func,
  hideToolTip: _propTypes.default.bool
};
PillBox.defaultProps = {
  text: '',
  type: PILL_TYPE.CHECK,
  className: '',
  status: '',
  tooltip: null,
  position: {
    left: '-27px',
    top: '26px'
  },
  t: function t(x) {
    return x;
  },
  hideToolTip: false
};
PillBox.PILL_TYPE = PILL_TYPE;
PillBox.PROPERTY_BADGE_STATUS_ICON = PROPERTY_BADGE_STATUS_ICON;
var _default = PillBox;
exports.default = _default;